import { Component, OnInit, ElementRef, ViewChild, OnDestroy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-gooey-button',
  templateUrl: './gooey-button.component.html',
  styleUrls: ['./gooey-button.component.scss'],
})
export class GooeyButtonComponent  implements OnInit {
  @ViewChild('gooeyBtn', { static: true }) gooeyBtn!: ElementRef;
  @Output() btnClick: EventEmitter<any> = new EventEmitter<any>();
  @Input() triggerAnimation: any;

  private intervalId: any;

  constructor() { }

  ngOnInit(): void {
   this.gooeyBtn.nativeElement.addEventListener('pointermove', this.moveBg.bind(this));
    this.gooeyBtn.nativeElement.addEventListener('pointerover', this.onPointerOver.bind(this));
    this.intro();
  }

  ngOnChanges(changes): void {
    if (changes['triggerAnimation'] && !changes['triggerAnimation'].firstChange) {
      this.intro();
    }
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  onClickBtn(event:Event) {
    this.btnClick.emit(event);
  }


moveBg(e: PointerEvent): void {
    const target = e.target as HTMLElement;
    const rect = target.getBoundingClientRect();
    target.style.setProperty('--x', String((e.clientX - rect.x) / rect.width * 100));
    target.style.setProperty('--y', String((e.clientY - rect.y) / rect.height * 100));
  }

  intro(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    };
    let i = 4;
    const btn = this.gooeyBtn.nativeElement;
    btn.classList.add('animating');
    btn.style.setProperty('--a', '100%');

    this.intervalId = setInterval(() => {
      btn.style.setProperty(
        '--x',
        String(((Math.cos(i) + 2) / 3.6) * 100)
      );
      btn.style.setProperty(
        '--y',
        String(((Math.sin(i) + 2) / 3.6) * 100)
      );
      i += 0.03;

      if (i > 11.5) {
        clearInterval(this.intervalId);
        btn.classList.remove('animating');
        btn.style.setProperty('--a', '');
      }
    }, 16);
  }

  onPointerOver(e: PointerEvent): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    const target = e.target as HTMLElement;
    target.style.setProperty('--a', '');
  }

}
